<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 8.47266H2.14453V9.52734H0V8.47266Z" fill="currentColor" />
    <path d="M15.8555 8.47266H18V9.52734H15.8555V8.47266Z" fill="currentColor" />
    <path d="M13.4746 3.77972L14.966 2.28833L15.7117 3.03403L14.2203 4.52542L13.4746 3.77972Z" fill="currentColor" />
    <path d="M3.77957 4.52527L2.28818 3.03387L3.03387 2.28818L4.52527 3.77957L3.77957 4.52527Z" fill="currentColor" />
    <path d="M8.47266 0H9.52734V2.14453H8.47266V0Z" fill="currentColor" />
    <path d="M4.25391 15.8906C3.67136 15.8906 3.19922 16.3628 3.19922 16.9453V18H14.8008V16.9453C14.8008 16.3628 14.3286 15.8906 13.7461 15.8906H4.25391Z" fill="currentColor" />
    <path d="M4.25391 9V14.8359H13.7461V9C13.7461 6.38292 11.6171 4.25391 9 4.25391C6.38292 4.25391 4.25391 6.38292 4.25391 9ZM8.47266 7.41797H9.52734V10.582H8.47266V7.41797ZM8.47266 11.6367H9.52734V12.6914H8.47266V11.6367Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'Urgent',
};
</script>
